import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Playlist } from '../../../models';

@Component({
  selector: 'match-playlists',
  templateUrl: './match-playlists.component.html',
  styleUrls: ['./match-playlists.component.css']
})
export class MatchPlaylistsComponent {
  @Input() playlists: Playlist[];

  @Output() readonly addPlaylist = new EventEmitter<{}>();
  @Output() readonly showPlaylist = new EventEmitter<Playlist>();
  @Output() readonly deletePlaylist = new EventEmitter<Playlist>();
  @Output() readonly editPlaylist = new EventEmitter<Playlist>();
  @Output() readonly exportPlaylistVideo = new EventEmitter<Playlist>();

  constructor() {
    console.info('[MatchPlaylistsComponent]', this.playlists);
  }

  onAddPlaylistClick(): void {
    this.addPlaylist.emit();
  }

  onPlaylistClick(playlist: Playlist) {
    console.info('[MatchPlaylistsComponent] Clicked Playlist: ', playlist);
    this.showPlaylist.emit(playlist);
  }

  onDeletePlaylistClick(playlist: Playlist) {
    this.deletePlaylist.emit(playlist);
  }

  onEditPlaylistClick(playlist: Playlist) {
    this.editPlaylist.emit(playlist);
  }

  onExportVideoClick(playlist: Playlist) {
    this.exportPlaylistVideo.emit(playlist);
  }
}
